import { gql } from "@apollo/client"

export const REGISTER_ACCOUNT = gql`
  mutation registerAccount(
    $company: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $password1: String!
    $password2: String!
    $recaptchaToken: String!
    $acceptsTc: Boolean!
  ) {
    registerAccount(
      company: $company
      email: $email
      firstName: $firstName
      lastName: $lastName
      password1: $password1
      password2: $password2
      recaptchaToken: $recaptchaToken
      acceptsTc: $acceptsTc
    ) {
      success
      errors {
        field
        messages
      }
    }
  }
`
